import React from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./SubjectGradeItem.scss";

export function SubjectGradeItem(props) {
  const { subjectGrade } = props;
  return (
    <>
      <div className="syllabu-item">
        <div className="syllabu-item__info">
          <span className="syllabu-item__info-name">
            {subjectGrade.subject.name}
          </span>
        </div>
        <div>
          <Popup
            content="Actualizar contenido"
            trigger={
              <Button
                icon
                primary
                as={Link}
                to={`/admin/media/${subjectGrade.id}/edit`}
              >
                <Icon name="edit" />
              </Button>
            }
          />
          <Popup
            content="Ver contenido"
            trigger={
              <Button
                icon
                color="red"
                as={Link}
                to={`/admin/media/${subjectGrade.id}/show`}
              >
                <Icon name="video play" />
              </Button>
            }
          />
        </div>
      </div>
    </>
  );
}
